

export class PushNotifModel {
    public subscriberId: number;
    public notifText: string;
    public country: string;
    public browser: string;
    public tokenParams: string;
    public sendDate: string;
    public deliveryDate: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/pushNotif.model.ts